import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "fw_admin_token";

export const setAdminToken = (token) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
};

export const getAdminToken = () => localStorage.getItem(TOKEN_KEY);

const authHeaders = () => {
  const t = getAdminToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const joinWaitlist = async (email, source = "landing_page") => {
  const res = await axios.post(`${API}/waitlist`, { email, source });
  return res.data;
};

export const updateWaitlistDetails = async (entryId, details) => {
  const res = await axios.patch(`${API}/waitlist/${entryId}`, details);
  return res.data;
};

export const getWaitlistCount = async () => {
  const res = await axios.get(`${API}/waitlist/count`);
  return res.data;
};

// ---- Admin ----
export const adminLogin = async (email, password) => {
  const res = await axios.post(`${API}/admin/login`, { email, password });
  return res.data;
};

export const adminMe = async () => {
  const res = await axios.get(`${API}/admin/me`, { headers: authHeaders() });
  return res.data;
};

export const adminListWaitlist = async ({ search = "", tag = "", platform = "" } = {}) => {
  const params = new URLSearchParams();
  if (search) params.set("search", search);
  if (tag) params.set("tag", tag);
  if (platform) params.set("platform", platform);
  const url = `${API}/admin/waitlist${params.toString() ? `?${params}` : ""}`;
  const res = await axios.get(url, { headers: authHeaders() });
  return res.data;
};

export const adminExportCsvUrl = (tag = "") => {
  const params = new URLSearchParams();
  if (tag) params.set("tag", tag);
  return `${API}/admin/waitlist.csv${params.toString() ? `?${params}` : ""}`;
};

export const adminDeleteEntry = async (id) => {
  const res = await axios.delete(`${API}/admin/waitlist/${id}`, { headers: authHeaders() });
  return res.data;
};

// ---- Content (CMS) ----
export const getContent = async () => {
  const res = await axios.get(`${API}/content`);
  return res.data;
};

export const saveContent = async (values) => {
  const res = await axios.put(`${API}/admin/content`, { values }, { headers: authHeaders() });
  return res.data;
};
